<template>
  <div>
    <div id="Chart1" style="width: 100%; height: 250px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts1() {
      var myChart1 = this.$echarts.init(document.getElementById("Chart1"));
      //配置图表
      var option1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        grid: {
          containLabel: true,
          left: 10,
          right: 10,
          bottom: 20,
          top: 20,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["01-20", "01-21", "01-22", "01-23", "01-24", "01-25"],
          offset: 20,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {},
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              if (value > 0) {
                return `+${value}%`;
              } else if (value == 0) {
                return `${value}%`;
              } else {
                return `${value}%`;
              }
            },
          },
        },
        series: [
          {
            name: "本基金",
            type: "line",
            smooth: true,
            symbol: "none",
            showSymbol: false,
            color: "#fcad2a",
            data: [25.01,24.56,18.71,16.35,27.81,28.63],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(252,173,42,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(252,173,42,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
          {
            name: "沪深300",
            type: "line",
            smooth: true,
            symbol: "none",
            showSymbol: false,
            color: "#539cff",
            data: [3.21,4.01,2.95,0.23,3.56,5],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(83,156,255,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(83,156,255,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
          {
            name: "同类均值",
            type: "line",
            smooth: true,
            symbol: "none",
            showSymbol: false,
            color: "#fd4c4c",
            data: [28.61,7.91,-4.12,4.61,2.13,-3.67],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(253,76,76,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(253,76,76,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
        ],
      };
      myChart1.setOption(option1);
    },
  },
  mounted() {
    this.myEcharts1();
  },
};
</script>

<style scoped>
#Chart1{
  margin-bottom: 12px;
}
</style>